module.exports = __webpack_public_path__ + "img/1.899256e0.png";